import {
	JsonConvert,
	JsonConverter,
	JsonCustomConvert,
	JsonObject,
	JsonProperty,
} from 'json2typescript';
import { BaseResponse } from '../../base-response';

@JsonConverter
export class SessionConverter implements JsonCustomConvert<Session> {
	serialize() { }
	deserialize(data: any): Session {
		const jsonConvert = new JsonConvert();
		return jsonConvert.deserializeObject(data, Session);
	}
}
@JsonConverter
export class SessionArrayConverter implements JsonCustomConvert<Array<Session>> {
	serialize() { }
	deserialize(data: any): Array<Session> {
		const jsonConvert = new JsonConvert();
		return jsonConvert.deserializeArray(data, Session);
	}
}

@JsonConverter
export class SessionListConverter implements JsonCustomConvert<SessionList> {
	serialize() { }
	deserialize(data: any): SessionList {
		const jsonConvert = new JsonConvert();
		return jsonConvert.deserializeObject(data, SessionList);
	}
}


@JsonObject('Session')
export class Session {
	@JsonProperty('session_id', String, true)
	session_id: string = '';
	@JsonProperty('location_id', String, true)
	location_id: string = '';
	@JsonProperty('start_time', Number, true)
	start_time: number = 0;
	@JsonProperty('end_time', Number, true)
	end_time: number = 0;
	@JsonProperty('mac_address', String, true)
	mac_address: string = '';
	@JsonProperty('ip', String, true)
	ip: string = '';
	@JsonProperty('username', String, true)
	username: string = '';
	@JsonProperty('identity_id', String, true)
	identity_id: string = '';
}

@JsonObject("SessionList")
export class SessionList {
	@JsonProperty("count", Number, true)
	count: number = 0;

	@JsonProperty("data", SessionArrayConverter, true)
	data: Array<Session> = new Array<Session>();
}

@JsonObject("SessionData")
export class SessionData extends BaseResponse {
	@JsonProperty("data", SessionConverter, true)
	data: Session = new Session();
}

@JsonObject("SessionListData")
export class SessionListData extends BaseResponse {
	@JsonProperty("data", SessionListConverter, true)
	data: SessionList = new SessionList();
}